// "More from The Joy of Pancakes" — five cards covering commissions,
// branded content, preservation kits, kandi, and take-home merch. Copy
// lives in data/pressOfferings.js; layout below.
//
// Accent rotation: each card foregrounds one of the pan-flag colors
// (pink / gold / sky) for border + title color so the grid doesn't read
// as five identical tiles. Five cards × three colors keeps no two
// adjacent cards using the same accent.

import { OFFERINGS } from "../data/pressOfferings";
import PanBar from "../components/PanBar";

const ACCENTS = {
  pink: {
    color: "var(--jop-pink)",
    border: "rgba(239,83,126,0.45)",
    glow: "rgba(239,83,126,0.18)",
    bg: "rgba(239,83,126,0.05)",
  },
  gold: {
    color: "var(--jop-gold)",
    border: "rgba(252,179,31,0.45)",
    glow: "rgba(252,179,31,0.18)",
    bg: "rgba(252,179,31,0.05)",
  },
  sky: {
    color: "var(--jop-highlight-blue)",
    border: "rgba(74,164,225,0.45)",
    glow: "rgba(74,164,225,0.18)",
    bg: "rgba(74,164,225,0.05)",
  },
};

export default function OtherOfferings() {
  return (
    <section
      id="offerings"
      style={{
        background: "radial-gradient(ellipse 70% 50% at 50% 0%, rgba(239,83,126,0.08) 0%, transparent 60%), #0a1c30",
        padding: "5rem 1.25rem",
        borderTop: "1px solid rgba(252,179,31,0.12)",
      }}
    >
      <div style={{ maxWidth: "1100px", margin: "0 auto" }}>
        <div style={{ textAlign: "center", marginBottom: "2.6rem" }}>
          <PanBar width={72} height={3} margin="0 auto 1.1rem" />
          <h2 style={{
            margin: "0 0 0.6rem",
            fontFamily: "var(--jop-script)",
            fontSize: "clamp(1.8rem, 4.5vw, 2.6rem)",
            color: "var(--jop-gold)",
            fontWeight: 700,
            letterSpacing: "-0.01em",
          }}>
            More from The Joy of Pancakes
          </h2>
          <p style={{
            margin: "0 auto",
            maxWidth: "640px",
            fontSize: "1rem",
            lineHeight: 1.6,
            color: "var(--jop-cream)",
            fontFamily: "var(--jop-display)",
            opacity: 0.85,
          }}>
            The live act is the centerpiece, but the world around it is bigger —
            commissions, kits, branded work, jewelry, take-home merch.
          </p>
        </div>

        <div className="jop-offerings-grid">
          {OFFERINGS.map((o) => {
            const a = ACCENTS[o.accent] || ACCENTS.gold;
            return (
              <article
                key={o.id}
                style={{
                  position: "relative",
                  background: a.bg,
                  border: `1px solid ${a.border}`,
                  borderRadius: "14px",
                  padding: "1.4rem 1.5rem 1.5rem",
                  fontFamily: "var(--jop-display)",
                  boxShadow: `0 8px 22px rgba(0,0,0,0.32), 0 0 24px ${a.glow}`,
                  display: "flex",
                  flexDirection: "column",
                }}
              >
                <h3 style={{
                  margin: "0 0 0.4rem",
                  fontFamily: "var(--jop-script)",
                  fontSize: "1.45rem",
                  lineHeight: 1.15,
                  color: a.color,
                  fontWeight: 700,
                }}>
                  {o.title}
                </h3>
                {o.price && (
                  <div style={{
                    fontSize: "0.78rem",
                    fontWeight: 800,
                    letterSpacing: "0.1em",
                    textTransform: "uppercase",
                    color: "rgba(255,218,173,0.65)",
                    marginBottom: "0.8rem",
                  }}>
                    {o.price}
                  </div>
                )}
                <p style={{
                  margin: 0,
                  fontSize: "0.96rem",
                  lineHeight: 1.65,
                  color: "var(--jop-cream)",
                  opacity: 0.94,
                }}>
                  {o.body}
                </p>
              </article>
            );
          })}
        </div>
      </div>

      <style>{`
        .jop-offerings-grid {
          display: grid;
          grid-template-columns: repeat(3, minmax(0, 1fr));
          gap: 1.2rem;
        }
        @media (max-width: 980px) {
          .jop-offerings-grid {
            grid-template-columns: repeat(2, minmax(0, 1fr));
          }
        }
        @media (max-width: 640px) {
          .jop-offerings-grid {
            grid-template-columns: 1fr;
          }
        }
      `}</style>
    </section>
  );
}
